'use client';

import { useStore } from '@tanstack/react-store';

import { LoginDrawerStore } from '@/features/stores/LoginDrawerStore';

const useLoginDrawer = () => {
  const loginDrawerType = useStore(LoginDrawerStore, (s) => s.type);

  const openDrawer = (drawerType: 'login' | 'register' | 'forgot_pass' | 'recover_pass') => {
    LoginDrawerStore.setState(() => ({ type: drawerType }));
  };

  const closeDrawer = () => {
    LoginDrawerStore.setState(() => ({ type: null }));
  };

  return { loginDrawerType, openDrawer, closeDrawer };
};

export default useLoginDrawer;
